var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5a61dc",
    d: "M18.018 6.21a.91.91 0 0 1 .268.647v15.086c0 1.01-.819 1.828-1.829 1.828H1.83A1.83 1.83 0 0 1 0 21.943V1.829C0 .819.818 0 1.829 0h9.6c.242 0 .474.096.646.268zm-8.875 10.4 3.531 2.104-.937-3.964 3.12-2.667-4.108-.344L9.143 8l-1.606 3.739-4.108.344 3.12 2.667-.938 3.964zm2.743-9.296h4.659L10.97 1.741V6.4c0 .505.41.914.915.914"
  })));
};
export default SvgFile;